import React, { useState, useRef } from 'react';
import { GoogleMap, useJsApiLoader, StandaloneSearchBox } from '@react-google-maps/api';

const GoogelMapAPI = ({setGetLocationAttributes}) => {
    const inputRef = useRef(null);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
        libraries: ["places"]
    });

    const handlePlacesChange = () => {
        const places = inputRef.current.getPlaces();
        if (places && places.length > 0) {
            const place = places[0];
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            setCoordinates({ lat, lng });
            setGetLocationAttributes({
                address: places[0].formatted_address,
                longitude: lng,
                latitude: lat
            })
        }
    };

    return (
        <>
            {isLoaded && (
                <StandaloneSearchBox onLoad={(ref) => inputRef.current = ref} onPlacesChanged={handlePlacesChange}>
                    <input type="text" className="form-control" name='address' placeholder="Enter your address" />
                </StandaloneSearchBox >
            )}
        </>
    );
};

export default GoogelMapAPI;